import {dom, library} from '@fortawesome/fontawesome-svg-core';

// brand
import {faYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube';

// solid
import {faAlignCenter} from '@fortawesome/free-solid-svg-icons/faAlignCenter';
import {faAlignJustify} from '@fortawesome/free-solid-svg-icons/faAlignJustify';
import {faAlignLeft} from '@fortawesome/free-solid-svg-icons/faAlignLeft';
import {faAlignRight} from '@fortawesome/free-solid-svg-icons/faAlignRight';
import {faAnchor} from '@fortawesome/free-solid-svg-icons/faAnchor';
import {faAngleDoubleDown} from '@fortawesome/free-solid-svg-icons/faAngleDoubleDown';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons/faAngleDown';
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight';
import {faArrowDown} from '@fortawesome/free-solid-svg-icons/faArrowDown';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons/faArrowRight';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons/faArrowUp';
import {faArrowsAltH} from '@fortawesome/free-solid-svg-icons/faArrowsAltH';
import {faAsterisk} from '@fortawesome/free-solid-svg-icons/faAsterisk';
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars';
import {faBirthdayCake} from '@fortawesome/free-solid-svg-icons/faBirthdayCake';
import {faBold} from '@fortawesome/free-solid-svg-icons/faBold';
import {faBorderAll} from '@fortawesome/free-solid-svg-icons/faBorderAll';
import {faBorderNone} from '@fortawesome/free-solid-svg-icons/faBorderNone';
import {faBug} from '@fortawesome/free-solid-svg-icons/faBug';
import {faBuilding} from '@fortawesome/free-solid-svg-icons/faBuilding';
import {faCalculator} from '@fortawesome/free-solid-svg-icons/faCalculator';
import {faCalendar} from '@fortawesome/free-solid-svg-icons/faCalendar';
import {faCalendarAlt} from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import {faCamera} from '@fortawesome/free-solid-svg-icons/faCamera';
import {faCampground} from '@fortawesome/free-solid-svg-icons/faCampground';
import {faCaretDown} from '@fortawesome/free-solid-svg-icons/faCaretDown';
import {faCaretUp} from '@fortawesome/free-solid-svg-icons/faCaretUp';
import {faChartLine} from '@fortawesome/free-solid-svg-icons/faChartLine';
import {faChartPie} from '@fortawesome/free-solid-svg-icons/faChartPie';
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import {faChevronCircleDown} from '@fortawesome/free-solid-svg-icons/faChevronCircleDown';
import {faChevronCircleUp} from '@fortawesome/free-solid-svg-icons/faChevronCircleUp';
import {faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight';
import {faChevronUp} from '@fortawesome/free-solid-svg-icons/faChevronUp';
import {faCircle} from '@fortawesome/free-solid-svg-icons/faCircle';
import {faCircleNotch} from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import {faCity} from '@fortawesome/free-solid-svg-icons/faCity';
import {faClipboardCheck} from '@fortawesome/free-solid-svg-icons/faClipboardCheck';
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock';
import {faClone} from '@fortawesome/free-solid-svg-icons/faClone';
import {faCodeBranch} from '@fortawesome/free-solid-svg-icons/faCodeBranch';
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog';
import {faCoins} from '@fortawesome/free-solid-svg-icons/faCoins';
import {faColumns} from '@fortawesome/free-solid-svg-icons/faColumns';
import {faComment} from '@fortawesome/free-solid-svg-icons/faComment';
import {faCommentDots} from '@fortawesome/free-solid-svg-icons/faCommentDots';
import {faCompress} from '@fortawesome/free-solid-svg-icons/faCompress';
import {faCopy} from '@fortawesome/free-solid-svg-icons/faCopy';
import {faCouch} from '@fortawesome/free-solid-svg-icons/faCouch';
import {faCrosshairs} from '@fortawesome/free-solid-svg-icons/faCrosshairs';
import {faDatabase} from '@fortawesome/free-solid-svg-icons/faDatabase';
import {faDollarSign} from '@fortawesome/free-solid-svg-icons/faDollarSign';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';
import {faDrawPolygon} from '@fortawesome/free-solid-svg-icons/faDrawPolygon';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {faEllipsisH} from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import {faEllipsisV} from '@fortawesome/free-solid-svg-icons/faEllipsisV';
import {faExchangeAlt} from '@fortawesome/free-solid-svg-icons/faExchangeAlt';
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import {faExpand} from '@fortawesome/free-solid-svg-icons/faExpand';
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye';
import {faEyeSlash} from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import {faFileExport} from '@fortawesome/free-solid-svg-icons/faFileExport';
import {faFileImport} from '@fortawesome/free-solid-svg-icons/faFileImport';
import {faFileInvoice} from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import {faFileUpload} from '@fortawesome/free-solid-svg-icons/faFileUpload';
import {faFileWord as fasFileWord} from '@fortawesome/free-solid-svg-icons/faFileWord';
import {faFilm} from '@fortawesome/free-solid-svg-icons/faFilm';
import {faFilter} from '@fortawesome/free-solid-svg-icons/faFilter';
import {faFlagCheckered} from '@fortawesome/free-solid-svg-icons/faFlagCheckered';
import {faFolder} from '@fortawesome/free-solid-svg-icons/faFolder';
import {faFont} from '@fortawesome/free-solid-svg-icons/faFont';
import {faGavel} from '@fortawesome/free-solid-svg-icons/faGavel';
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe';
import {faGripLines} from '@fortawesome/free-solid-svg-icons/faGripLines';
import {faGripVertical} from '@fortawesome/free-solid-svg-icons/faGripVertical';
import {faHandHoldingUsd} from '@fortawesome/free-solid-svg-icons/faHandHoldingUsd';
import {faHeading} from '@fortawesome/free-solid-svg-icons/faHeading';
import {faHighlighter} from '@fortawesome/free-solid-svg-icons/faHighlighter';
import {faHistory} from '@fortawesome/free-solid-svg-icons/faHistory';
import {faHome} from '@fortawesome/free-solid-svg-icons/faHome';
import {faHourglassEnd} from '@fortawesome/free-solid-svg-icons/faHourglassEnd';
import {faHourglassHalf} from '@fortawesome/free-solid-svg-icons/faHourglassHalf';
import {faICursor} from '@fortawesome/free-solid-svg-icons/faICursor';
import {faImage} from '@fortawesome/free-solid-svg-icons/faImage';
import {faImages} from '@fortawesome/free-solid-svg-icons/faImages';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import {faItalic} from '@fortawesome/free-solid-svg-icons/faItalic';
import {faKey} from '@fortawesome/free-solid-svg-icons/faKey';
import {faLayerGroup} from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import {faLeaf} from '@fortawesome/free-solid-svg-icons/faLeaf';
import {faLightbulb} from '@fortawesome/free-solid-svg-icons/faLightbulb';
import {faLink} from '@fortawesome/free-solid-svg-icons/faLink';
import {faListAlt} from '@fortawesome/free-solid-svg-icons/faListAlt';
import {faListOl} from '@fortawesome/free-solid-svg-icons/faListOl';
import {faListUl} from '@fortawesome/free-solid-svg-icons/faListUl';
import {faLock} from '@fortawesome/free-solid-svg-icons/faLock';
import {faMagic} from '@fortawesome/free-solid-svg-icons/faMagic';
import {faMap} from '@fortawesome/free-solid-svg-icons/faMap';
import {faMapMarkedAlt} from '@fortawesome/free-solid-svg-icons/faMapMarkedAlt';
import {faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import {faMicrophone} from '@fortawesome/free-solid-svg-icons/faMicrophone';
import {faMinus} from '@fortawesome/free-solid-svg-icons/faMinus';
import {faMinusCircle} from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import {faMobileAlt} from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import {faNetworkWired} from '@fortawesome/free-solid-svg-icons/faNetworkWired';
import {faObjectUngroup} from '@fortawesome/free-solid-svg-icons/faObjectUngroup';
import {faPalette} from '@fortawesome/free-solid-svg-icons/faPalette';
import {faPaperclip} from '@fortawesome/free-solid-svg-icons/faPaperclip';
import {faParagraph} from '@fortawesome/free-solid-svg-icons/faParagraph';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import {faPercentage} from '@fortawesome/free-solid-svg-icons/faPercentage';
import {faPiggyBank} from '@fortawesome/free-solid-svg-icons/faPiggyBank';
import {faPlane} from '@fortawesome/free-solid-svg-icons/faPlane';
import {faPlay} from '@fortawesome/free-solid-svg-icons/faPlay';
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import {faPollH} from '@fortawesome/free-solid-svg-icons/faPollH';
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import {faReceipt} from '@fortawesome/free-solid-svg-icons/faReceipt';
import {faRedo} from '@fortawesome/free-solid-svg-icons/faRedo';
import {faRetweet} from '@fortawesome/free-solid-svg-icons/faRetweet';
import {faRoad} from '@fortawesome/free-solid-svg-icons/faRoad';
import {faRobot} from '@fortawesome/free-solid-svg-icons/faRobot';
import {faRoute} from '@fortawesome/free-solid-svg-icons/faRoute';
import {faRuler} from '@fortawesome/free-solid-svg-icons/faRuler';
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {faSearchPlus} from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import {faSeedling} from '@fortawesome/free-solid-svg-icons/faSeedling';
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import {faSort} from '@fortawesome/free-solid-svg-icons/faSort';
import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown';
import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp';
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';
import {faStamp} from '@fortawesome/free-solid-svg-icons/faStamp';
import {faStar} from '@fortawesome/free-solid-svg-icons/faStar';
import {faStop} from '@fortawesome/free-solid-svg-icons/faStop';
import {faStore} from '@fortawesome/free-solid-svg-icons/faStore';
import {faStream} from '@fortawesome/free-solid-svg-icons/faStream';
import {faStreetView} from '@fortawesome/free-solid-svg-icons/faStreetView';
import {faStrikethrough} from '@fortawesome/free-solid-svg-icons/faStrikethrough';
import {faSubscript} from '@fortawesome/free-solid-svg-icons/faSubscript';
import {faSuperscript} from '@fortawesome/free-solid-svg-icons/faSuperscript';
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import {faTable} from '@fortawesome/free-solid-svg-icons/faTable';
import {faTachometerAlt} from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import {faTasks} from '@fortawesome/free-solid-svg-icons/faTasks';
import {faThLarge} from '@fortawesome/free-solid-svg-icons/faThLarge';
import {faThumbsUp} from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import {faThumbtack} from '@fortawesome/free-solid-svg-icons/faThumbtack';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {faToggleOff} from '@fortawesome/free-solid-svg-icons/faToggleOff';
import {faToggleOn} from '@fortawesome/free-solid-svg-icons/faToggleOn';
import {faTools} from '@fortawesome/free-solid-svg-icons/faTools';
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash';
import {faTrashRestore} from '@fortawesome/free-solid-svg-icons/faTrashRestore';
import {faTree} from '@fortawesome/free-solid-svg-icons/faTree';
import {faTrophy} from '@fortawesome/free-solid-svg-icons/faTrophy';
import {faUnderline} from '@fortawesome/free-solid-svg-icons/faUnderline';
import {faUndo} from '@fortawesome/free-solid-svg-icons/faUndo';
import {faUniversity} from '@fortawesome/free-solid-svg-icons/faUniversity';
import {faUpload} from '@fortawesome/free-solid-svg-icons/faUpload';
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser';
import {faUserPlus} from '@fortawesome/free-solid-svg-icons/faUserPlus';
import {faUserSecret} from '@fortawesome/free-solid-svg-icons/faUserSecret';
import {faUserTag} from '@fortawesome/free-solid-svg-icons/faUserTag';
import {faUserTie} from '@fortawesome/free-solid-svg-icons/faUserTie';
import {faUsers} from '@fortawesome/free-solid-svg-icons/faUsers';
import {faVectorSquare} from '@fortawesome/free-solid-svg-icons/faVectorSquare';
import {faWallet} from '@fortawesome/free-solid-svg-icons/faWallet';
import {faWarehouse} from '@fortawesome/free-solid-svg-icons/faWarehouse';

// regular
import {faCheckSquare as farCheckSquare} from '@fortawesome/free-regular-svg-icons/faCheckSquare';
import {faEnvelope} from '@fortawesome/free-regular-svg-icons/faEnvelope';
import {faFile} from '@fortawesome/free-regular-svg-icons/faFile';
import {faFileAlt} from '@fortawesome/free-regular-svg-icons/faFileAlt';
import {faFileArchive} from '@fortawesome/free-regular-svg-icons/faFileArchive';
import {faFileExcel} from '@fortawesome/free-regular-svg-icons/faFileExcel';
import {faFileImage} from '@fortawesome/free-regular-svg-icons/faFileImage';
import {faFilePdf} from '@fortawesome/free-regular-svg-icons/faFilePdf';
import {faFileWord} from '@fortawesome/free-regular-svg-icons/faFileWord';
import {faFlag as farFlag} from '@fortawesome/free-regular-svg-icons/faFlag';
import {faSquare as farSquare} from '@fortawesome/free-regular-svg-icons/faSquare';
import {faStar as farStar} from '@fortawesome/free-regular-svg-icons/faStar';

library.add(
    // brand
    faYoutube,

    // solid
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faAnchor,
    faAngleDoubleDown,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowsAltH,
    faAsterisk,
    faBars,
    faBirthdayCake,
    faBold,
    faBorderAll,
    faBorderNone,
    faBug,
    faBuilding,
    faCalculator,
    faCalendar,
    faCalendarAlt,
    faCamera,
    faCampground,
    faCaretDown,
    faCaretUp,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faCity,
    faClipboardCheck,
    faClock,
    faClone,
    faCodeBranch,
    faCog,
    faCoins,
    faColumns,
    faComment,
    faCommentDots,
    faCompress,
    faCopy,
    faCouch,
    faCrosshairs,
    faDatabase,
    faDollarSign,
    faDownload,
    faDrawPolygon,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faExchangeAlt,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFileExport,
    faFileImport,
    faFileInvoice,
    faFileUpload,
    fasFileWord,
    faFilm,
    faFilter,
    faFlagCheckered,
    faFolder,
    faFont,
    faGavel,
    faGlobe,
    faGripLines,
    faGripVertical,
    faHandHoldingUsd,
    faHeading,
    faHighlighter,
    faHistory,
    faHome,
    faHourglassEnd,
    faHourglassHalf,
    faICursor,
    faImage,
    faImages,
    faInfoCircle,
    faItalic,
    faKey,
    faLayerGroup,
    faLeaf,
    faLightbulb,
    faLink,
    faListAlt,
    faListOl,
    faListUl,
    faLock,
    faMagic,
    faMap,
    faMapMarkedAlt,
    faMapMarkerAlt,
    faMicrophone,
    faMinus,
    faMinusCircle,
    faMobileAlt,
    faNetworkWired,
    faObjectUngroup,
    faPalette,
    faPaperclip,
    faParagraph,
    faPencilAlt,
    faPercentage,
    faPiggyBank,
    faPlane,
    faPlay,
    faPlus,
    faPlusCircle,
    faPollH,
    faQuestionCircle,
    faReceipt,
    faRedo,
    faRetweet,
    faRoad,
    faRobot,
    faRoute,
    faRuler,
    faShoppingCart,
    faSearch,
    faSearchPlus,
    faSeedling,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStamp,
    faStar,
    faStop,
    faStore,
    faStream,
    faStreetView,
    faStrikethrough,
    faSubscript,
    faSuperscript,
    faSyncAlt,
    faTable,
    faTachometerAlt,
    faTasks,
    faThLarge,
    faThumbsUp,
    faThumbtack,
    faTimes,
    faToggleOff,
    faToggleOn,
    faTools,
    faTrash,
    faTrashRestore,
    faTree,
    faTrophy,
    faUnderline,
    faUndo,
    faUniversity,
    faUpload,
    faUser,
    faUserPlus,
    faUserSecret,
    faUserTag,
    faUserTie,
    faUsers,
    faVectorSquare,
    faWallet,
    faWarehouse,

    // regular
    faEnvelope,
    faFile,
    faFileAlt,
    faFileArchive,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFileWord,
    farCheckSquare,
    farFlag,
    farSquare,
    farStar,
);
dom.watch();
